/* eslint-disable no-case-declarations */
import produce from 'immer'
import { v4 as uuidv4 } from 'uuid'
import { actions } from './actions'

const initialState = {
  ventas: {
    data: [],
    loading: false,
    error: '',
  },
  ventaTraspasada: {
    data: null,
    loading: false,
    error: '',
  },
  ventaItemPersonalizado: {
    data: [],
    loading: false,
    error: '',
  },
  observaciones: {
    data: [],
    loading: false,
    error: '',
  },
  estadosBultos: {
    data: [],
    loading: false,
    error: '',
  },
  todasBandejas: {
    data: [],
    loading: false,
    error: '',
  },
  bandejas: {
    data: [],
    loading: false,
    error: '',
  },
  bandeja: {
    data: [],
    loading: false,
    error: '',
  },
  bandejasLog: {
    data: [],
    loading: false,
    error: '',
  },
  estanterias: {
    data: [],
    loading: false,
    error: '',
  },
  estantesLlenos: {
    data: [],
    loading: false,
    error: '',
  },
  mailObservacionesTemplate: {
    data: [],
    loading: false,
    error: '',
  },
  venta: {
    data: null,
    loading: false,
    error: '',
    loadingAbonos: false,
    loadingCupones: false,
    loadingObservacionesBulto: false,
    loadingObservacionesCierre: false,
    loadingBultosCheck: false,
    loadingFinalizarImprimir: false,
    loadingEstanteAleatorio: false,
    loadingItemVenta: false,
    estanteriaPreseleccionada: null,
    estanteForzado: null,
  },
  cupones: {
    data: null,
    loading: false,
    error: '',
  },
  enviarMailObservacionVenta: {
    data: null,
    loading: false,
    error: '',
  },
  dhls: {
    data: [],
    loading: false,
    error: '',
    reload: false,
  },
  dhlsSinAlbaran: {
    data: [],
    loading: false,
    error: '',
  },
  seurs: {
    data: [],
    loading: false,
    error: '',
    reload: false,
  },
  seursSinAlbaran: {
    data: [],
    loading: false,
    error: '',
  },
  correosExpress: {
    data: [],
    loading: false,
    error: '',
    reload: false,
  },
  mrwsClicks: {
    data: [],
    loading: false,
    error: '',
    reload: false,
  },
  ventaItemsMarcadosEliminar: [],
  codigoBarrasCerrar: {
    data: null,
    loading: false,
    error: '',
  },
  codigoBarrasEstanteria: {
    data: null,
    loading: false,
    error: '',
  },
  ventasBandeja: {
    data: [],
    loading: false,
    error: '',
  },
  ordenEstanteria: {
    data: null,
    loading: false,
    error: '',
  },
  modificacionesVenta: {
    data: [],
    loading: false,
    error: '',
  },

  pedidosMensajero: {
    data: [],
    loading: false,
    error: '',
  },

  pedidosSinMensajero: {
    data: [],
    loading: false,
    error: '',
  },
  pedidosAmazon: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function ventasReducer(state = initialState, action) {
  switch (action.type) {
    // El traspaso puede tardar: copia items y dispara la duplicación de diseños, así que el modal
    // necesita saber cuándo termina para mantener el loading y no cerrarse antes de tiempo.
    case actions.TRASPASAR_VENTA_REQUESTED:
      return {
        ...state,
        ventaTraspasada: { ...state.ventaTraspasada, loading: true, error: '' },
      }
    case actions.TRASPASAR_VENTA_SUCCEEDED:
      return {
        ...state,
        ventaTraspasada: { ...state.ventaTraspasada, data: action.payload, loading: false },
      }
    case actions.TRASPASAR_VENTA_FILED:
      return {
        ...state,
        ventaTraspasada: { ...state.ventaTraspasada, loading: false, error: action.error || '' },
      }

    case actions.VENTAS_LOAD_REQUESTED:
      return { ...state, ventas: { ...state.ventas, loading: true } }
    case actions.VENTAS_LOAD_SUCCEEDED:
      return {
        ...state,
        ventas: { ...state.ventas, data: action.payload, loading: false },
      }
    case actions.VENTAS_LOAD_FILED:
      return {
        ...state,
        ventas: { ...state.ventas, loading: false },
      }

    case actions.VENTAS_RELOAD_VENTA_REQUESTED:
      return state
    case actions.VENTAS_RELOAD_VENTA_SUCCEEDED: {
      const newData = state.ventas.data.map(venta => {
        if (venta.id === action.payload.id) {
          return {
            ...action.payload,
          }
        }
        return venta
      })
      return {
        ...state,
        ventas: {
          ...state.ventas,
          data: newData,
          loading: false,
        },
      }
    }
    case actions.VENTAS_RELOAD_VENTA_FILED:
      return {
        ...state,
        ventas: { ...state.ventas, loading: false },
      }

    case actions.VENTAS_CLEAR:
      return { ...state, ventas: { ...state.ventas, data: null, loading: false } }

    case actions.VENTAS_FILTER_LOAD_REQUESTED:
      return { ...state, ventas: { ...state.ventas, loading: true, data: null } }
    case actions.VENTAS_TILDAR_FILTER_LOAD_REQUESTED:
      return { ...state, ventas: { ...state.ventas, loading: true, data: null } }
    case actions.VENTAS_FILTER_LOAD_SUCCEEDED:
      return {
        ...state,
        ventas: { ...state.ventas, data: action.payload, loading: false },
      }
    case actions.VENTAS_FILTER_LOAD_FILED:
      return {
        ...state,
        ventas: { ...state.ventas, loading: false },
      }

    case actions.VENTAS_FILTER_AMAZON_LOAD_REQUESTED:
      return { ...state, ventas: { ...state.ventas, loading: true } }
    case actions.VENTAS_FILTER_AMAZON_LOAD_SUCCEEDED:
      return {
        ...state,
        ventas: { ...state.ventas, data: action.payload, loading: false },
      }
    case actions.VENTAS_FILTER_AMAZON_LOAD_FAILED:
      return {
        ...state,
        ventas: { ...state.ventas, loading: false },
      }

    case actions.VENTAS_FILTER_MENSAJEROS_NUESTROS_LOAD_REQUESTED:
      return { ...state, ventas: { ...state.ventas, loading: true } }
    case actions.VENTAS_FILTER_MENSAJEROS_NUESTROS_LOAD_SUCCEEDED:
      return {
        ...state,
        ventas: { ...state.ventas, data: action.payload, loading: false },
      }
    case actions.VENTAS_FILTER_MENSAJEROS_NUESTROS_LOAD_FILED:
      return {
        ...state,
        ventas: { ...state.ventas, loading: false },
      }

    case actions.VENTAS_FILTER_GRABADOS_SIN_PERSO_LOAD_REQUESTED:
      return { ...state, ventas: { ...state.ventas, loading: true } }
    case actions.VENTAS_FILTER_GRABADOS_SIN_PERSO_LOAD_SUCCEEDED:
      return {
        ...state,
        ventas: { ...state.ventas, data: action.payload, loading: false },
      }
    case actions.VENTAS_FILTER_GRABADOS_SIN_PERSO_LOAD_FAILED:
      return {
        ...state,
        ventas: { ...state.ventas, loading: false },
      }

    case actions.VENTAS_FILTER_BORDADOS_SIN_PERSO_LOAD_REQUESTED:
      return { ...state, ventas: { ...state.ventas, loading: true } }
    case actions.VENTAS_FILTER_BORDADOS_SIN_PERSO_LOAD_SUCCEEDED:
      return {
        ...state,
        ventas: { ...state.ventas, data: action.payload, loading: false },
      }
    case actions.VENTAS_FILTER_BORDADOS_SIN_PERSO_LOAD_FAILED:
      return {
        ...state,
        ventas: { ...state.ventas, loading: false },
      }

    case actions.VENTAS_FILTER_RESCATE_LOAD_REQUESTED:
      return { ...state, ventas: { ...state.ventas, loading: true } }
    case actions.VENTAS_FILTER_RESCATE_LOAD_SUCCEEDED:
      return {
        ...state,
        ventas: { ...state.ventas, data: action.payload, loading: false },
      }
    case actions.VENTAS_FILTER_RESCATE_LOAD_FILED:
      return {
        ...state,
        ventas: { ...state.ventas, loading: false },
      }
    case actions.VENTAS_FILTER_PERSONALIZADOS_LOAD_REQUESTED:
      return { ...state, ventas: { ...state.ventas, loading: true } }
    case actions.VENTAS_FILTER_PERSONALIZADOS_LOAD_SUCCEEDED:
      return {
        ...state,
        ventas: { ...state.ventas, data: action.payload, loading: false },
      }
    case actions.VENTAS_FILTER_PERSONALIZADOS_LOAD_FILED:
      return {
        ...state,
        ventas: { ...state.ventas, loading: false },
      }
    case actions.VENTAS_FILTER_PERSONALIZADOS_TOTAL_LOAD_REQUESTED:
      return { ...state, ventas: { ...state.ventas, loading: true } }
    case actions.VENTAS_FILTER_PERSONALIZADOS_TOTAL_LOAD_SUCCEEDED:
      return {
        ...state,
        ventas: { ...state.ventas, data: action.payload, loading: false },
      }
    case actions.VENTAS_FILTER_PERSONALIZADOS_TOTAL_LOAD_FILED:
      return {
        ...state,
        ventas: { ...state.ventas, loading: false },
      }

    case actions.VENTAS_FILTER_PERSONALIZADOS_PREPARADOS_LOAD_REQUESTED:
      return { ...state, ventas: { ...state.ventas, loading: true } }
    case actions.VENTAS_FILTER_PERSONALIZADOS_PREPARADOS_LOAD_SUCCEEDED:
      return {
        ...state,
        ventas: { ...state.ventas, data: action.payload, loading: false },
      }
    case actions.VENTAS_FILTER_PERSONALIZADOS_PREPARADOS_LOAD_FILED:
      return {
        ...state,
        ventas: { ...state.ventas, loading: false },
      }

    case actions.VENTAS_FILTER_PERSONALIZADOS_FABRICADOS_LOAD_REQUESTED:
      return { ...state, ventas: { ...state.ventas, loading: true } }
    case actions.VENTAS_FILTER_PERSONALIZADOS_FABRICADOS_LOAD_SUCCEEDED:
      return {
        ...state,
        ventas: { ...state.ventas, data: action.payload, loading: false },
      }
    case actions.VENTAS_FILTER_PERSONALIZADOS_FABRICADOS_LOAD_FAILED:
      return {
        ...state,
        ventas: { ...state.ventas, loading: false },
      }

    case actions.VENTAS_FILTER_EN_SOBRE_LOAD_REQUESTED:
      return { ...state, ventas: { ...state.ventas, loading: true } }
    case actions.VENTAS_FILTER_EN_SOBRE_LOAD_SUCCEEDED:
      return {
        ...state,
        ventas: { ...state.ventas, data: action.payload, loading: false },
      }
    case actions.VENTAS_FILTER_EN_SOBRE_LOAD_FILED:
      return {
        ...state,
        ventas: { ...state.ventas, loading: false },
      }
    case actions.VENTAS_FILTER_TODOS_LOAD_REQUESTED:
      return { ...state, ventas: { ...state.ventas, loading: true } }
    case actions.VENTAS_FILTER_TODOS_LOAD_SUCCEEDED:
      return {
        ...state,
        ventas: { ...state.ventas, data: action.payload, loading: false },
      }
    case actions.VENTAS_FILTER_TODOS_LOAD_FAILED:
      return {
        ...state,
        ventas: { ...state.ventas, loading: false },
      }
    case actions.VENTAS_FILTER_NOCTURNOS_LOAD_REQUESTED:
      return { ...state, ventas: { ...state.ventas, loading: true } }
    case actions.VENTAS_FILTER_NOCTURNOS_LOAD_SUCCEEDED:
      return {
        ...state,
        ventas: { ...state.ventas, data: action.payload, loading: false },
      }
    case actions.VENTAS_FILTER_NOCTURNOS_LOAD_FILED:
      return {
        ...state,
        ventas: { ...state.ventas, loading: false },
      }
    case actions.VENTAS_FILTER_DIURNOS_LOAD_REQUESTED:
      return { ...state, ventas: { ...state.ventas, loading: true } }
    case actions.VENTAS_FILTER_DIURNOS_LOAD_SUCCEEDED:
      return {
        ...state,
        ventas: { ...state.ventas, data: action.payload, loading: false },
      }
    case actions.VENTAS_FILTER_DIURNOS_LOAD_FILED:
      return {
        ...state,
        ventas: { ...state.ventas, loading: false },
      }
    case actions.VENTAS_FILTER_FIGURAS_LEGO_LOAD_REQUESTED:
      return { ...state, ventas: { ...state.ventas, loading: true } }
    case actions.VENTAS_FILTER_FIGURAS_LEGO_LOAD_SUCCEEDED:
      return {
        ...state,
        ventas: { ...state.ventas, data: action.payload, loading: false },
      }
    case actions.VENTAS_FILTER_FIGURAS_LEGO_LOAD_FAILED:
      return {
        ...state,
        ventas: { ...state.ventas, loading: false },
      }
    case actions.VENTAS_FILTER_ECOMMERCE_LOAD_REQUESTED:
      return { ...state, ventas: { ...state.ventas, loading: true } }
    case actions.VENTAS_FILTER_ECOMMERCE_LOAD_SUCCEEDED:
      return {
        ...state,
        ventas: { ...state.ventas, data: action.payload, loading: false },
      }
    case actions.VENTAS_FILTER_ECOMMERCE_LOAD_FILED:
      return {
        ...state,
        ventas: { ...state.ventas, loading: false },
      }
    case actions.VENTAS_FILTER_ECOMMERCE_TRAMO_HORARIO_LOAD_REQUESTED:
      return { ...state, ventas: { ...state.ventas, loading: true } }
    case actions.VENTAS_FILTER_ECOMMERCE_TRAMO_HORARIO_LOAD_SUCCEEDED:
      return {
        ...state,
        ventas: { ...state.ventas, data: action.payload, loading: false },
      }
    case actions.VENTAS_FILTER_ECOMMERCE_TRAMO_HORARIO_LOAD_FILED:
      return {
        ...state,
        ventas: { ...state.ventas, loading: false },
      }
    case actions.VENTAS_FILTER_LOCAL_LOAD_REQUESTED:
      return { ...state, ventas: { ...state.ventas, loading: true } }
    case actions.VENTAS_FILTER_LOCAL_LOAD_SUCCEEDED:
      return {
        ...state,
        ventas: { ...state.ventas, data: action.payload, loading: false },
      }
    case actions.VENTAS_FILTER_LOCAL_LOAD_FILED:
      return {
        ...state,
        ventas: { ...state.ventas, loading: false },
      }
    case actions.VENTAS_FILTER_DIGITAL_LOAD_REQUESTED:
      return { ...state, ventas: { ...state.ventas, loading: true } }
    case actions.VENTAS_FILTER_DIGITAL_LOAD_SUCCEEDED:
      return {
        ...state,
        ventas: { ...state.ventas, data: action.payload, loading: false },
      }
    case actions.VENTAS_FILTER_DIGITAL_LOAD_FILED:
      return {
        ...state,
        ventas: { ...state.ventas, loading: false },
      }
    case actions.VENTAS_FILTER_EMPLEADOS_LOAD_REQUESTED:
      return { ...state, ventas: { ...state.ventas, loading: true } }
    case actions.VENTAS_FILTER_EMPLEADOS_LOAD_SUCCEEDED:
      return {
        ...state,
        ventas: { ...state.ventas, data: action.payload, loading: false },
      }
    case actions.VENTAS_FILTER_EMPLEADOS_LOAD_FILED:
      return {
        ...state,
        ventas: { ...state.ventas, loading: false },
      }
    case actions.VENTAS_FILTER_EKOMI_LOAD_REQUESTED:
      return { ...state, ventas: { ...state.ventas, loading: true } }
    case actions.VENTAS_FILTER_EKOMI_LOAD_SUCCEEDED:
      return {
        ...state,
        ventas: { ...state.ventas, data: action.payload, loading: false },
      }
    case actions.VENTAS_FILTER_EKOMI_LOAD_FILED:
      return {
        ...state,
        ventas: { ...state.ventas, loading: false },
      }
    case actions.VENTAS_FILTER_FUERA_DE_ESPANA_LOAD_REQUESTED:
      return { ...state, ventas: { ...state.ventas, loading: true } }
    case actions.VENTAS_FILTER_FUERA_DE_ESPANA_LOAD_SUCCEEDED:
      return {
        ...state,
        ventas: { ...state.ventas, data: action.payload, loading: false },
      }
    case actions.VENTAS_FILTER_FUERA_DE_ESPANA_LOAD_FILED:
      return {
        ...state,
        ventas: { ...state.ventas, loading: false },
      }
    case actions.VENTAS_FILTER_FUERA_DE_ESPANA_SEUR_LOAD_REQUESTED:
      return { ...state, ventas: { ...state.ventas, loading: true } }
    case actions.VENTAS_FILTER_FUERA_DE_ESPANA_SEUR_LOAD_SUCCEEDED:
      return {
        ...state,
        ventas: { ...state.ventas, data: action.payload, loading: false },
      }
    case actions.VENTAS_FILTER_FUERA_DE_ESPANA_SEUR_LOAD_FILED:
      return {
        ...state,
        ventas: { ...state.ventas, loading: false },
      }
    case actions.VENTAS_FILTER_FUERA_DE_ESPANA_DHL_LOAD_REQUESTED:
      return { ...state, ventas: { ...state.ventas, loading: true } }
    case actions.VENTAS_FILTER_FUERA_DE_ESPANA_DHL_LOAD_SUCCEEDED:
      return {
        ...state,
        ventas: { ...state.ventas, data: action.payload, loading: false },
      }
    case actions.VENTAS_FILTER_FUERA_DE_ESPANA_DHL_LOAD_FILED:
      return {
        ...state,
        ventas: { ...state.ventas, loading: false },
      }
    case actions.VENTAS_FILTER_DHL_LOAD_REQUESTED:
      return { ...state, ventas: { ...state.ventas, loading: true } }
    case actions.VENTAS_FILTER_DHL_LOAD_SUCCEEDED:
      return {
        ...state,
        ventas: { ...state.ventas, data: action.payload, loading: false },
      }
    case actions.VENTAS_FILTER_DHL_LOAD_FILED:
      return {
        ...state,
        ventas: { ...state.ventas, loading: false },
      }
    case actions.VENTAS_FILTER_NUESTROS_NOCTURNO_LOAD_REQUESTED:
      return { ...state, ventas: { ...state.ventas, loading: true } }
    case actions.VENTAS_FILTER_NUESTROS_NOCTURNO_LOAD_SUCCEEDED:
      return {
        ...state,
        ventas: { ...state.ventas, data: action.payload, loading: false },
      }
    case actions.VENTAS_FILTER_NUESTROS_NOCTURNO_LOAD_FAILED:
      return {
        ...state,
        ventas: { ...state.ventas, loading: false },
      }
    case actions.VENTAS_FILTER_CHOCOMENSAJE_MASIVO_LOAD_REQUESTED:
      return { ...state, ventas: { ...state.ventas, loading: true } }
    case actions.VENTAS_FILTER_CHOCOMENSAJE_MASIVO_LOAD_SUCCEEDED:
      return {
        ...state,
        ventas: { ...state.ventas, data: action.payload, loading: false },
      }
    case actions.VENTAS_FILTER_CHOCOMENSAJE_MASIVO_LOAD_FAILED:
      return {
        ...state,
        ventas: { ...state.ventas, loading: false },
      }

    case actions.VENTAS_FILTER_NOCTURNOS_CORREOS_LOAD_REQUESTED:
      return { ...state, ventas: { ...state.ventas, loading: true } }
    case actions.VENTAS_FILTER_NOCTURNOS_CORREOS_LOAD_SUCCEEDED:
      return {
        ...state,
        ventas: { ...state.ventas, data: action.payload, loading: false },
      }
    case actions.VENTAS_FILTER_NOCTURNOS_CORREOS_LOAD_FAILED:
      return {
        ...state,
        ventas: { ...state.ventas, loading: false },
      }

    case actions.OBSERVACIONES_VENTA_LOAD_REQUESTED:
      return { ...state, observaciones: { ...state.observaciones, loading: true } }
    case actions.OBSERVACIONES_VENTA_LOAD_SUCCEEDED:
      return {
        ...state,
        observaciones: { ...state.observaciones, data: action.payload, loading: false },
      }
    case actions.OBSERVACIONES_VENTA_LOAD_FILED:
      return {
        ...state,
        observaciones: { ...state.observaciones, loading: false },
      }
    case actions.MAIL_OBSERVACION_TEMPLATE_VENTA_LOAD_REQUESTED:
      return {
        ...state,
        mailObservacionesTemplate: { ...state.mailObservacionesTemplate, loading: true },
      }
    case actions.MAIL_OBSERVACION_TEMPLATE_VENTA_LOAD_SUCCEEDED:
      return {
        ...state,
        mailObservacionesTemplate: {
          ...state.mailObservacionesTemplate,
          data: action.payload,
          loading: false,
        },
      }
    case actions.MAIL_OBSERVACION_TEMPLATE_VENTA_LOAD_FAILED:
      return {
        ...state,
        mailObservacionesTemplate: { ...state.mailObservacionesTemplate, loading: false },
      }
    case actions.MAIL_OBSERVACION_TEMPLATE_INSERT_SUCCEEDED:
      return {
        ...state,
        mailObservacionesTemplate: {
          ...state.mailObservacionesTemplate,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.MAIL_OBSERVACION_TEMPLATE_UPDATE_SUCCEEDED:
      return {
        ...state,
        mailObservacionesTemplate: {
          ...state.mailObservacionesTemplate,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.MAIL_OBSERVACION_TEMPLATE_UPDATE_REQUESTED:
      return {
        ...state,
        mailObservacionesTemplate: {
          ...state.mailObservacionesTemplate,
          loading: true,
          error: '',
        },
      }
    case actions.MAIL_OBSERVACION_TEMPLATE_UPDATE_FAILED:
      return {
        ...state,
        mailObservacionesTemplate: {
          ...state.mailObservacionesTemplate,
          loading: false,
          error: action.error,
        },
      }
    case actions.DELETE_MAIL_OBSERVACION_TEMPLATE_REQUESTED:
      return {
        ...state,
        mailObservacionesTemplate: { ...state.mailObservacionesTemplate, loading: true },
      }
    case actions.DELETE_MAIL_OBSERVACION_TEMPLATE_SUCCEEDED:
      return {
        ...state,
        mailObservacionesTemplate: {
          ...state.mailObservacionesTemplate,
          loading: false,
          data: state.mailObservaciones.data.filter(ob => ob.id !== action.payload),
        },
      }
    case actions.DELETE_MAIL_OBSERVACION_TEMPLATE_FAILED:
      return {
        ...state,
        mailObservacionesTemplate: {
          ...state.mailObservacionesTemplate,
          loading: false,
          error: action.error,
        },
      }
    case actions.VENTA_BYID_LOAD_REQUESTED:
      return {
        ...state,
        venta: { ...state.venta, loading: action?.background ? !action.background : true },
      }
    case actions.VENTA_BYID_LOAD_SUCCEEDED:
      return {
        ...state,
        venta: { ...state.venta, data: action.payload, loading: false },
      }
    case actions.VENTA_BYID_LOAD_FILED:
      return {
        ...state,
        venta: { ...state.venta, loading: false },
      }

    case actions.VENTA_UPDATE_REQUESTED:
      return {
        ...state,
        venta: { ...state.venta, loading: true, error: '' },
      }
    case actions.VENTA_UPDATE_SUCCEEDED:
      return {
        ...state,
        venta: {
          ...state.venta,
          data: { ...state.venta.data, ...action.payload },
          loading: false,
          error: '',
        },
      }
    case actions.VENTA_UPDATE_FILED:
      return {
        ...state,
        venta: { ...state.venta, loading: false, error: action.error },
      }
    case actions.OBSERVACION_SEGUIMIENTO_VENTA_INSERT_REQUESTED:
      return {
        ...state,
        venta: { ...state.venta, loading: true, error: '' },
      }
    case actions.OBSERVACION_SEGUIMIENTO_VENTA_INSERT_SUCCEEDED:
      return {
        ...state,
        venta: {
          ...state.venta,
          data: {
            ...state.venta.data,
            // Insertar la observacion actualiza tambien la fila Venta (RowVersion nuevo);
            // lo reflejamos aqui para que la siguiente actualizacion de la venta no choque.
            timestamp: action.payload?.timestamp ?? state.venta.data.timestamp,
            observacionesSeguimientoList: [
              action.payload,
              ...state.venta.data.observacionesSeguimientoList,
            ],
          },
          loading: false,
          error: '',
        },
      }
    case actions.OBSERVACION_SEGUIMIENTO_VENTA_INSERT_FILED:
      return {
        ...state,
        venta: { ...state.venta, loading: false, error: action.error },
      }
    case actions.OBSERVACION_INSERT_REQUESTED:
      return {
        ...state,
        observaciones: { ...state.observaciones, loading: true, error: '' },
      }
    case actions.OBSERVACION_INSERT_SUCCEEDED:
      return {
        ...state,
        observaciones: {
          ...state.observaciones,
          data: [].concat(action.payload, state.observaciones.data),
          loading: false,
          error: '',
        },
      }
    case actions.OBSERVACION_INSERT_FILED:
      return {
        ...state,
        observaciones: { ...state.observaciones, loading: false, error: action.error },
      }

    case actions.OBSERVACION_UPDATE_REQUESTED:
      return {
        ...state,
        observaciones: { ...state.observaciones, loading: true, error: '' },
      }
    case actions.OBSERVACION_UPDATE_SUCCEEDED:
      return {
        ...state,
        observaciones: {
          ...state.observaciones,
          data: state.observaciones.data.map(obs =>
            obs.id === action.payload.id ? action.payload : obs,
          ),
          loading: false,
          error: '',
        },
      }
    case actions.OBSERVACION_UPDATE_FILED:
      return {
        ...state,
        observaciones: { ...state.observaciones, loading: false, error: action.error },
      }
    case actions.ABONO_DELETE_REQUESTED:
      return { ...state, venta: { ...state.venta, loadingAbonos: true } }
    case actions.ABONO_DELETE_SUCCEEDED:
      return {
        ...state,
        venta: {
          ...state.venta,
          loadingAbonos: false,
          data: {
            ...state.venta.data,
            abonosList: state.venta.data.abonosList.filter(abono => abono.id !== action.payload),
          },
        },
      }
    case actions.ABONO_DELETE_FILED:
      return {
        ...state,
        venta: { ...state.venta, loadingAbonos: false },
      }
    case actions.OBSERVACION_DELETE_REQUESTED:
      return { ...state, observaciones: { ...state.observaciones } }
    case actions.OBSERVACION_DELETE_SUCCEEDED:
      return {
        ...state,
        observaciones: {
          ...state.observaciones,
          data: state.observaciones.data.filter(obs => obs.id !== action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.OBSERVACION_DELETE_FILED:
      return {
        ...state,
        observaciones: { ...state.observaciones },
      }
    case actions.ESTANTES_LLENOS_LOAD_REQUESTED:
      return { ...state, estantesLlenos: { ...state.estantesLlenos, loading: true } }
    case actions.ESTANTES_LLENOS_LOAD_SUCCEEDED:
      return {
        ...state,
        estantesLlenos: { ...state.estantesLlenos, data: action.payload, loading: false },
      }
    case actions.ESTANTES_LLENOS_LOAD_FILED:
      return {
        ...state,
        estantesLlenos: { ...state.estantesLlenos, loading: false },
      }
    case actions.ESTANTERIAS_LOAD_REQUESTED:
      return { ...state, estanterias: { ...state.estanterias, loading: true } }
    case actions.ESTANTERIAS_LOAD_SUCCEEDED:
      return {
        ...state,
        estanterias: { ...state.estanterias, data: action.payload, loading: false },
      }
    case actions.ESTANTERIAS_LOAD_FILED:
      return {
        ...state,
        estanterias: { ...state.estanterias, loading: false },
      }

    case actions.CODIGO_BARRAS_ESTANTERIA_LOAD_REQUESTED:
      return {
        ...state,
        codigoBarrasEstanteria: { ...state.codigoBarrasEstanteria, loading: true },
      }
    case actions.CODIGO_BARRAS_ESTANTERIA_LOAD_SUCCEEDED:
      return {
        ...state,
        codigoBarrasEstanteria: {
          ...state.codigoBarrasEstanteria,
          data: action.payload,
          loading: false,
        },
      }
    case actions.CODIGO_BARRAS_ESTANTERIA_LOAD_FILED:
      return {
        ...state,
        codigoBarrasEstanteria: { ...state.codigoBarrasEstanteria, loading: false },
      }

    case actions.BANDEJAS_LOG_LOAD_REQUESTED:
      return { ...state, bandejasLog: { ...state.bandejasLog, loading: true } }
    case actions.BANDEJAS_LOG_LOAD_SUCCEEDED:
      return {
        ...state,
        bandejasLog: { ...state.bandejasLog, data: action.payload, loading: false },
      }
    case actions.BANDEJAS_LOG_LOAD_FILED:
      return {
        ...state,
        bandejasLog: { ...state.bandejasLog, loading: false },
      }
    case actions.BANDEJAS_LOAD_REQUESTED:
      return { ...state, bandejas: { ...state.bandejas, loading: true } }
    case actions.BANDEJAS_LOAD_SUCCEEDED:
      return {
        ...state,
        bandejas: { ...state.bandejas, data: action.payload, loading: false },
      }
    case actions.BANDEJAS_LOAD_FILED:
      return {
        ...state,
        bandejas: { ...state.bandejas, loading: false },
      }
    case actions.TODAS_BANDEJAS_LOAD_REQUESTED:
      return { ...state, todasBandejas: { ...state.todasBandejas, loading: true } }
    case actions.TODAS_BANDEJAS_LOAD_SUCCEEDED:
      return {
        ...state,
        todasBandejas: { ...state.todasBandejas, data: action.payload, loading: false },
      }
    case actions.TODAS_BANDEJAS_LOAD_FILED:
      return {
        ...state,
        todasBandejas: { ...state.todasBandejas, loading: false },
      }
    case actions.BANDEJA_LOAD_REQUESTED:
      return { ...state, bandeja: { ...state.bandeja, loading: true } }
    case actions.BANDEJA_LOAD_SUCCEEDED:
      return {
        ...state,
        bandeja: { ...state.bandeja, data: action.payload, loading: false },
      }
    case actions.BANDEJA_LOAD_FILED:
      return {
        ...state,
        bandeja: { ...state.bandeja, loading: false },
      }
    case actions.TODAS_BANDEJAS_VACIAR_REQUESTED:
      return { ...state, todasBandejas: { ...state.todasBandejas, loading: true } }
    case actions.TODAS_BANDEJAS_VACIAR_SUCCEEDED:
      return {
        ...state,
        todasBandejas: { ...state.todasBandejas, loading: false },
      }
    case actions.TODAS_BANDEJAS_VACIAR_FILED:
      return {
        ...state,
        todasBandejas: { ...state.todasBandejas, loading: false },
      }
    case actions.BANDEJA_VACIAR_REQUESTED:
      return {
        ...state,
        bandeja: { ...state.bandeja, loading: true },
        ventasBandeja: { ...state.ventasBandeja, loading: true },
      }
    case actions.BANDEJA_VACIAR_SUCCEEDED:
      return {
        ...state,
        bandeja: { data: [], loading: false },
        ventasBandeja: { data: [], loading: false },
      }
    case actions.BANDEJA_VACIAR_FILED:
      return {
        ...state,
        bandeja: { ...state.bandeja, loading: false },
        ventasBandeja: { ...state.ventasBandeja, loading: false },
      }
    case actions.ESTADOS_BULTOS_LOAD_REQUESTED:
      return { ...state, estadosBultos: { ...state.estadosBultos, loading: true } }
    case actions.ESTADOS_BULTOS_LOAD_SUCCEEDED:
      return {
        ...state,
        estadosBultos: { ...state.estadosBultos, data: action.payload, loading: false },
      }
    case actions.ESTADOS_BULTOS_LOAD_FILED:
      return {
        ...state,
        estadosBultos: { ...state.estadosBultos, loading: false },
      }
    case actions.ESTADOS_BULTOS_INSERT_REQUESTED:
      return {
        ...state,
        estadosBultos: { ...state.estadosBultos, loading: true, error: '' },
      }
    case actions.ESTADOS_BULTOS_INSERT_SUCCEEDED:
      return {
        ...state,
        estadosBultos: {
          ...state.estadosBultos,
          data: [].concat(action.payload, state.estadosBultos.data),
          loading: false,
          error: '',
        },
      }
    case actions.ESTADOS_BULTOS_INSERT_FILED:
      return {
        ...state,
        estadosBultos: { ...state.estadosBultos, loading: false, error: action.error },
      }

    case actions.ESTANTERIA_INSERT_REQUESTED:
      return {
        ...state,
        estanterias: { ...state.estanterias, loading: true, error: '' },
      }
    case actions.ESTANTERIA_INSERT_SUCCEEDED:
      return {
        ...state,
        estanterias: {
          ...state.estanterias,
          data: [].concat(state.estanterias.data, action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.ESTANTERIA_INSERT_FILED:
      return {
        ...state,
        estanterias: { ...state.estanterias, loading: false, error: action.error },
      }
    case actions.ESTADOS_BULTOS_UPDATE_REQUESTED:
      return {
        ...state,
        estadosBultos: { ...state.estadosBultos, loading: true, error: '' },
      }
    case actions.ESTADOS_BULTOS_UPDATE_SUCCEEDED:
      return {
        ...state,
        estadosBultos: {
          ...state.estadosBultos,
          data: state.estadosBultos.data.map(est =>
            est.id === action.payload.id ? action.payload : est,
          ),
          loading: false,
          error: '',
        },
      }
    case actions.ESTADOS_BULTOS_UPDATE_FILED:
      return {
        ...state,
        estadosBultos: { ...state.estadosBultos, loading: false, error: action.error },
      }

    case actions.ESTANTERIA_UPDATE_REQUESTED:
      return {
        ...state,
        estanterias: { ...state.estanterias, loading: true, error: '' },
      }
    case actions.ESTANTERIA_UPDATE_SUCCEEDED:
      return {
        ...state,
        estanterias: {
          ...state.estanterias,
          data: state.estanterias.data.map(est =>
            est.id === action.payload.id ? action.payload : est,
          ),
          loading: false,
          error: '',
        },
      }
    case actions.ESTANTERIA_UPDATE_FILED:
      return {
        ...state,
        estanterias: { ...state.estanterias, loading: false, error: action.error },
      }

    case actions.BANDEJA_TERMINADA_REQUESTED:
      return {
        ...state,
        estanterias: { ...state.bandeja, loading: true, error: '' },
      }
    case actions.BANDEJA_TERMINADA_SUCCEEDED:
      return {
        ...state,
        estanterias: {
          ...state.bandeja,
          data: state.bandeja.data.map(est => est.terminada === action.payload.terminada),
          loading: false,
          error: '',
        },
      }
    case actions.BANDEJA_TERMINADA_FILED:
      return {
        ...state,
        estanterias: { ...state.bandeja, loading: false, error: action.error },
      }

    case actions.ESTANTE_VENTA_LOAD_REQUESTED:
      return { ...state, ventasBandeja: { ...state.ventasBandeja, loading: true } }
    case actions.ESTANTE_VENTA_LOAD_SUCCEEDED:
      return {
        ...state,
        ventasBandeja: {
          ...state.ventasBandeja,
          data: [...state.ventasBandeja.data, action.payload],
          loading: false,
        },
      }
    case actions.ESTANTE_VENTA_LOAD_FILED:
      return {
        ...state,
        ventasBandeja: { ...state.ventasBandeja, loading: false },
      }

    case actions.SET_VENTA_BANDEJA_REQUESTED:
      return {
        ...state,
        ventasBandeja: { ...state.ventasBandeja, loading: true },
      }
    case actions.SET_VENTA_BANDEJA_SUCCEEDED:
      return {
        ...state,
        ventasBandeja: {
          ...state.ventasBandeja,
          data: state.ventasBandeja.data.map(item =>
            item.id === action.payload.id ? action.payload : item,
          ),
          loading: false,
        },
      }
    case actions.SET_VENTA_BANDEJA_FILED:
      return {
        ...state,
        ventasBandeja: { ...state.ventasBandeja, loading: false },
      }

    case actions.REMOVE_VENTA_ESTANTE_REQUESTED:
      return {
        ...state,
        ventasBandeja: { ...state.ventasBandeja, loading: true },
      }
    case actions.REMOVE_VENTA_ESTANTE_SUCCEEDED:
      console.log('action.payload', action.payload);
      return {
        ...state,

        ventasBandeja: {
          ...state.ventasBandeja,
          data: state.ventasBandeja.data.map(item =>
            item.id === action.payload.id ? action.payload : item
          ),
          loading: false,
        },
        venta: {
          ...state.venta,
          data:
            state.venta.data?.id === action.payload.id
              ? {
                  ...state.venta.data,
                  estante: null,
                }
              : state.venta.data,
        },

         estantesLlenos: {
          ...state.estantesLlenos,
          data: state.estantesLlenos.data.filter(
            e => e.ventaId !== action.payload.id
          ),
        },
        
      }
    case actions.REMOVE_VENTA_ESTANTE_FILED:
      return {
        ...state,
        ventasBandeja: { ...state.ventasBandeja, loading: false },
      }

    case actions.DELETE_VENTA_BANDEJA_REQUESTED:
      return {
        ...state,
        ventasBandeja: { ...state.ventasBandeja, loading: true },
      }
    case actions.DELETE_VENTA_BANDEJA_SUCCEEDED:
      return {
        ...state,
        ventasBandeja: {
          ...state.ventasBandeja,
          data: state.ventasBandeja.data.filter(item => item.id !== action.payload.id),
          loading: false,
        },
      }
    case actions.DELETE_VENTA_BANDEJA_FILED:
      return {
        ...state,
        ventasBandeja: { ...state.ventasBandeja, loading: false },
      }

    case actions.REMOVE_VENTA_BANDEJA_REQUESTED:
      return {
        ...state,
        ventasBandeja: { ...state.ventasBandeja, loading: true },
      }
    case actions.REMOVE_VENTA_BANDEJA_SUCCEEDED:
      return {
        ...state,
        ventasBandeja: {
          ...state.ventasBandeja,
          data: state.ventasBandeja.data.filter(item => item.id !== Number(action.payload)),
          loading: false,
        },
      }
    case actions.REMOVE_VENTA_BANDEJA_FILED:
      return {
        ...state,
        ventasBandeja: { ...state.ventasBandeja, loading: false },
      }

    case actions.REMOVE_ALL_VENTA_BANDEJA_REQUESTED:
      return {
        ...state,
        ventasBandeja: { ...state.ventasBandeja, loading: true },
      }
    case actions.REMOVE_ALL_VENTA_BANDEJA_SUCCEEDED:
      return {
        ...state,
        ventasBandeja: {
          ...state.ventasBandeja,
          data: [],
          loading: false,
        },
      }
    case actions.REMOVE_ALL_VENTA_BANDEJA_FILED:
      return {
        ...state,
        ventasBandeja: { ...state.ventasBandeja, loading: false },
      }

    case actions.ESTADOS_BULTOS_DELETE_REQUESTED:
      return { ...state, estadosBultos: { ...state.estadosBultos } }
    case actions.ESTADOS_BULTOS_DELETE_SUCCEEDED:
      return {
        ...state,
        estadosBultos: {
          ...state.estadosBultos,
          data: state.estadosBultos.data.filter(obs => obs.id !== action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.ESTADOS_BULTOS_DELETE_FILED:
      return {
        ...state,
        estadosBultos: { ...state.estadosBultos },
      }

    case actions.ESTANTERIA_DELETE_REQUESTED:
      return { ...state, estanterias: { ...state.estanterias } }
    case actions.ESTANTERIA_DELETE_SUCCEEDED:
      return {
        ...state,
        estanterias: {
          ...state.estanterias,
          data: state.estanterias.data.filter(est => est.id !== action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.ESTANTERIA_DELETE_FILED:
      return {
        ...state,
        estanterias: { ...state.estanterias },
      }
    case actions.CUPON_DELETE_REQUESTED:
      return { ...state, venta: { ...state.venta, loadingCupones: true } }
    case actions.CUPON_DELETE_SUCCEEDED:
      return {
        ...state,
        venta: {
          ...state.venta,
          loadingCupones: false,
          data: {
            ...state.venta.data,
            cuponesList: state.venta.data.cuponesList.filter(cupon => cupon.id !== action.payload),
          },
        },
      }
    case actions.CUPON_DELETE_FILED:
      return {
        ...state,
        venta: { ...state.venta, loadingCupones: false },
      }
    case actions.CUPONES_LOAD_REQUESTED:
      return { ...state, cupones: { ...state.cupones, loading: true } }
    case actions.CUPONES_LOAD_SUCCEEDED:
      return {
        ...state,
        cupones: { ...state.cupones, data: action.payload, loading: false },
      }
    case actions.CUPONES_LOAD_FILED:
      return {
        ...state,
        cupones: { ...state.cupones, loading: false },
      }

    case actions.ADD_CUPONES_REQUESTED:
      return { ...state, venta: { ...state.venta, loadingCupones: true } }
    case actions.ADD_CUPONES_SUCCEEDED:
      return {
        ...state,
        venta: {
          ...state.venta,
          loadingCupones: false,
          data: {
            ...state.venta.data,
            cuponesList: state.venta.data.cuponesList.concat(action.payload),
          },
        },
      }
    case actions.ADD_CUPONES_FILED:
      return {
        ...state,
        venta: { ...state.venta, loadingCupones: false },
      }

    case actions.ADD_ITEM_VENTA_PERSONALIZADO_REQUESTED:
      return {
        ...state,
        ventaItemPersonalizado: { ...state.ventaItemPersonalizado, loading: true },
      }
    case actions.ADD_ITEM_VENTA_PERSONALIZADO_SUCCEEDED:
      return {
        ...state,
        ventaItemPersonalizado: {
          ...state.ventaItemPersonalizado,
          loading: false,
          data: {
            ...state.ventaItemPersonalizado.data,
            data: state.ventaItemPersonalizado.data.concat(action.payload),
          },
        },
      }
    case actions.ADD_ITEM_VENTA_PERSONALIZADO_FILED:
      return {
        ...state,
        ventaItemPersonalizado: { ...state.ventaItemPersonalizado, loading: false },
      }

    case actions.CANCELAR_VENTA_REQUESTED:
      return { ...state, venta: { ...state.venta, loading: true } }
    case actions.CANCELAR_VENTA_SUCCEEDED:
      return {
        ...state,
        venta: {
          ...state.venta,
          loading: false,
          data: {
            ...state.venta.data,
            status: action.payload.status,
            pagado: action.payload.pagado,
            fechaPago: action.payload.fechaPago,
            timestamp: action.payload.timestamp,
          },
        },
      }
    case actions.CANCELAR_VENTA_FILED:
      return {
        ...state,
        venta: { ...state.venta, loading: false },
      }
    case actions.OBSERVACION_SEGUIMIENTO_PREPARACION_EMERGENTE_VENTA_INSERT_REQUESTED:
      return {
        ...state,
        venta: { ...state.venta, loading: true, error: '' },
      }
    case actions.OBSERVACION_SEGUIMIENTO_PREPARACION_EMERGENTE_VENTA_INSERT_SUCCEEDED:
      return {
        ...state,
        venta: {
          ...state.venta,
          data: {
            ...state.venta.data,
            // Insertar la observacion actualiza tambien la fila Venta (RowVersion nuevo);
            // lo reflejamos aqui para que la siguiente actualizacion de la venta no choque.
            timestamp: action.payload?.timestamp ?? state.venta.data.timestamp,
            observacionesPreparacionVentaList: [
              action.payload,
              ...state.venta.data.observacionesPreparacionVentaList,
            ],
          },
          loading: false,
          error: '',
        },
      }
    case actions.OBSERVACION_SEGUIMIENTO_PREPARACION_EMERGENTE_VENTA_INSERT_FILED:
      return {
        ...state,
        venta: { ...state.venta, loading: false, error: action.error },
      }
    case actions.ENVIAR_MAIL_OBSERVACION_VENTA_REQUESTED:
      return {
        ...state,
        enviarMailObservacionVenta: { ...state.enviarMailObservacionVenta, loading: true },
      }
    case actions.ENVIAR_MAIL_OBSERVACION_VENTA_SUCCEEDED:
      return {
        ...state,
        enviarMailObservacionVenta: { ...state.enviarMailObservacionVenta, loading: false },
      }
    case actions.ENVIAR_MAIL_OBSERVACION_VENTA_FILED:
      return {
        ...state,
        enviarMailObservacionVenta: { ...state.enviarMailObservacionVenta, loading: false },
      }

    case actions.ENVIAR_MAIL_OBSERVACION_VENTA_DONE_REQUESTED:
      return {
        ...state,
        enviarMailObservacionVenta: { ...state.enviarMailObservacionVenta, loading: false },
      }
    case actions.ENVIAR_MAIL_OBSERVACION_VENTA_DONE_SUCCEEDED: {
      const element = state.venta.data.mailObservacionesVentaList.find(
        e => e.mailObservacionTemplateId === action.payload.mailObservacionTemplateId,
      )
      if (element !== null && element !== undefined) {
        action.payload.cantidad = element.cantidad + 1
      }
      return {
        ...state,
        venta: {
          ...state.venta,
          data: {
            ...state.venta.data,
            mailObservacionesVentaList: [
              action.payload,
              ...state.venta.data.mailObservacionesVentaList,
            ],
          },
          loading: false,
          error: '',
        },
        enviarMailObservacionVenta: { ...state.enviarMailObservacionVenta, loading: false },
      }
    }
    case actions.ENVIAR_MAIL_OBSERVACION_VENTA_DONE_FILED:
      return {
        ...state,
        enviarMailObservacionVenta: { ...state.enviarMailObservacionVenta, loading: false },
      }
    case actions.BORRAR_MENSAJERO_REQUESTED:
      return { ...state, venta: { ...state.venta, loading: true } }
    case actions.BORRAR_MENSAJERO_SUCCEEDED:
      return {
        ...state,
        venta: {
          ...state.venta,
          loading: false,
          data: {
            ...state.venta.data,
            timestamp: action.payload.timestamp,
          },
        },
      }
    case actions.BORRAR_MENSAJERO_FILED:
      return {
        ...state,
        venta: { ...state.venta, loading: false },
      }

    case actions.BORRAR_BANDEJA_REQUESTED:
      return { ...state, venta: { ...state.venta, loading: true } }
    case actions.BORRAR_BANDEJA_SUCCEEDED:
      state.venta.data.cesta = ''
      return {
        ...state,
        venta: {
          ...state.venta,
          loading: false,
          data: {
            ...state.venta.data,
            timestamp: action.payload.timestamp,
          },
        },
      }
    case actions.BORRAR_BANDEJA_FILED:
      return {
        ...state,
        venta: { ...state.venta, loading: false },
      }

    case actions.MARCAR_PAGADO_REQUESTED:
      return { ...state, venta: { ...state.venta, loadingMarcarPagado: true } }
    case actions.MARCAR_PAGADO_SUCCEEDED:
      return {
        ...state,
        venta: {
          ...state.venta,
          loadingMarcarPagado: false,
          data: {
            ...state.venta.data,
            pagado: action.payload.pagado,
            fechaPago: action.payload.fechaPago,
            timestamp: action.payload.timestamp,
          },
        },
      }
    case actions.MARCAR_PAGADO_FILED:
      return {
        ...state,
        venta: { ...state.venta, loadingMarcarPagado: false },
      }

    case actions.ASIGNAR_NUMERO_FACTURA_SUCCEEDED:
      return {
        ...state,
        venta: {
          ...state.venta,
          data: {
            ...state.venta.data,
            numeroFactura: action.payload.numeroFactura,
            fechaFactura: action.payload.fechaFactura,
            timestamp: action.payload.timestamp,
          },
        },
      }

    case actions.INSERTAR_NUEVA_DEVOLUCION_REQUESTED:
      return { ...state, venta: { ...state.venta, loading: true } }
    case actions.INSERTAR_NUEVA_DEVOLUCION_SUCCEEDED:
      return {
        ...state,
        venta: {
          ...state.venta,
          loading: false,
          data: {
            ...state.venta.data,
            timestamp: action.payload.timestamp,
          },
        },
      }
    case actions.INSERTAR_NUEVA_DEVOLUCION_FILED:
      return {
        ...state,
        venta: { ...state.venta, loading: false },
      }
    case actions.ANULAR_DEVOLUCION_REQUESTED:
      return { ...state, venta: { ...state.venta, loading: true } }
    case actions.ANULAR_DEVOLUCION_SUCCEEDED:
      return {
        ...state,
        venta: {
          ...state.venta,
          loading: false,
          data: {
            ...state.venta.data,
            timestamp: action.payload.timestamp,
          },
        },
      }
    case actions.ANULAR_DEVOLUCION_FILED:
      return {
        ...state,
        venta: { ...state.venta, loading: false },
      }
    case actions.SET_VENTA_LETRA_REQUESTED:
      return { ...state, venta: { ...state.venta, loading: true } }
    case actions.SET_VENTA_LETRA_SUCCEEDED:
      return {
        ...state,
        venta: {
          ...state.venta,
          loading: false,
          data: {
            ...state.venta.data,
            timestamp: action.payload.timestamp,
          },
        },
      }
    case actions.SET_VENTA_LETRA_FILED:
      return {
        ...state,
        venta: { ...state.venta, loading: false },
      }
    case actions.SET_VENTA_VIP_REQUESTED:
      return { ...state, venta: { ...state.venta, loading: true } }
    case actions.SET_VENTA_VIP_SUCCEEDED:
      return {
        ...state,
        venta: {
          ...state.venta,
          loading: false,
          data: {
            ...state.venta.data,
            vip: state.venta.data.vip === null ? true : !state.venta.data.vip,
            timestamp: action.payload.timestamp,
          },
        },
      }
    case actions.SET_VENTA_VIP_FILED:
      return {
        ...state,
        venta: { ...state.venta, loading: false },
      }
    case actions.INSERT_ABONO_REQUESTED:
      return { ...state, venta: { ...state.venta, loading: true } }
    case actions.INSERT_ABONO_SUCCEEDED:
      return {
        ...state,
        venta: {
          ...state.venta,
          loading: false,
          data: {
            ...state.venta.data,
            timestamp: action.payload.timestamp,
            abonosList: action.payload.abonosList,
          },
        },
      }
    case actions.INSERT_ABONO_FILED:
      return {
        ...state,
        venta: { ...state.venta, loading: false },
      }
    case actions.DHL_BUSCAR_REQUESTED:
      return { ...state, dhls: { ...state.dhls, loading: true, data: null, reload: false } }
    case actions.DHL_BUSCAR_SUCCEEDED:
      return {
        ...state,
        dhls: { ...state.dhls, data: action.payload, loading: false, reload: false },
      }
    case actions.DHL_BUSCAR_FILED:
      return {
        ...state,
        dhls: { ...state.dhls, loading: false, reload: false },
      }
    case actions.DHL_DHL_BUSCAR_REQUESTED:
      return { ...state, dhls: { ...state.dhls, loading: true, data: null, reload: false } }
    case actions.DHL_DHL_BUSCAR_SUCCEEDED:
      return {
        ...state,
        dhls: { ...state.dhls, data: action.payload, loading: false, reload: false },
      }
    case actions.DHL_DHL_BUSCAR_FILED:
      return {
        ...state,
        dhls: { ...state.dhls, loading: false, reload: false },
      }
    case actions.VENTA_CAMBIAR_ESTADO_MENSAJERIA_REQUESTED:
      return {
        ...state,
        dhlsSinAlbaran: { ...state.dhlsSinAlbaran, loading: true, data: null },
        dhls: { ...state.dhls, loading: true, reload: false },
      }
    case actions.VENTA_CAMBIAR_ESTADO_MENSAJERIA_SUCCEEDED:
      return {
        ...state,
        dhlsSinAlbaran: { ...state.dhlsSinAlbaran, data: action.payload, loading: false },
        dhls: { ...state.dhls, loading: false, reload: true },
      }
    case actions.VENTA_CAMBIAR_ESTADO_MENSAJERIA_FILED:
      return {
        ...state,
        dhlsSinAlbaran: { ...state.dhlsSinAlbaran, loading: false },
        dhls: { ...state.dhls, loading: false, reload: false },
      }
    case actions.VENTA_CAMBIAR_ESTADO_MENSAJERIA_CORREOS_EXPRESS_REQUESTED:
      return {
        ...state,
        correosExpress: { ...state.correosExpress, loading: true, reload: false },
      }
    case actions.VENTA_CAMBIAR_ESTADO_MENSAJERIA_CORREOS_EXPRESS_SUCCEEDED:
      return {
        ...state,
        correosExpress: { ...state.correosExpress, loading: false, reload: true },
      }
    case actions.VENTA_CAMBIAR_ESTADO_MENSAJERIA_CORREOS_EXPRESS_FILED:
      return {
        ...state,
        correosExpress: { ...state.correosExpress, loading: false, reload: false },
      }
    case actions.VENTA_CAMBIAR_ESTADO_MENSAJERIA_SEUR_REQUESTED:
      return {
        ...state,
        seursSinAlbaran: { ...state.seursSinAlbaran, loading: true, data: null },
        seurs: { ...state.seurs, loading: true, reload: false },
      }
    case actions.VENTA_CAMBIAR_ESTADO_MENSAJERIA_SEUR_SUCCEEDED:
      return {
        ...state,
        seursSinAlbaran: { ...state.seursSinAlbaran, data: action.payload, loading: false },
        seurs: { ...state.seurs, loading: false, reload: true },
      }
    case actions.VENTA_CAMBIAR_ESTADO_MENSAJERIA_SEUR_FILED:
      return {
        ...state,
        seursSinAlbaran: { ...state.seursSinAlbaran, loading: false },
        seurs: { ...state.seurs, loading: false, reload: false },
      }
    case actions.SET_VENTA_ITEM_FALTANTE: {
      const faltanteInfo = action.payload
      const ventaItemsCarritoAdmin = [...state.venta.data.ventaItemsCarritoAdmin]
      const ventaItemExistente = ventaItemsCarritoAdmin.find(
        i => i.ventaItem.id === faltanteInfo.ventaItemId,
      )
      ventaItemsCarritoAdmin[ventaItemsCarritoAdmin.indexOf(ventaItemExistente)] = {
        ...ventaItemExistente,
        ventaItem: {
          ...ventaItemExistente.ventaItem,
          faltante: faltanteInfo.faltante,
          faltanteRegistro: faltanteInfo.faltanteRegistro,
          faltanteTexto: faltanteInfo.faltanteTexto,
        },
      }

      return {
        ...state,
        venta: {
          ...state.venta,
          data: {
            ...state.venta.data,
            ventaItemsCarritoAdmin,
          },
        },
      }
    }
    case actions.CORREOS_EXPRESS_BUSCAR_REQUESTED:
      return {
        ...state,
        correosExpress: { ...state.correosExpress, loading: true, data: null, reload: false },
      }
    case actions.CORREOS_EXPRESS_BUSCAR_SUCCEEDED:
      return {
        ...state,
        correosExpress: {
          ...state.correosExpress,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.CORREOS_EXPRESS_BUSCAR_FAILED:
      return {
        ...state,
        correosExpress: { ...state.correosExpress, loading: false, reload: false },
      }
    case actions.CORREOS_EXPRESS_ECOMMERCE_REQUESTED:
      return {
        ...state,
        correosExpress: { ...state.correosExpress, loading: true, data: null, reload: false },
      }
    case actions.CORREOS_EXPRESS_ECOMMERCE_SUCCEEDED:
      return {
        ...state,
        correosExpress: {
          ...state.correosExpress,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.CORREOS_EXPRESS_ECOMMERCE_FAILED:
      return {
        ...state,
        correosExpress: { ...state.correosExpress, loading: false, reload: false },
      }
    case actions.CORREOS_EXPRESS_ECOMMERCE_TRAMO_REQUESTED:
      return {
        ...state,
        correosExpress: { ...state.correosExpress, loading: true, data: null, reload: false },
      }
    case actions.CORREOS_EXPRESS_ECOMMERCE_TRAMO_SUCCEEDED:
      return {
        ...state,
        correosExpress: {
          ...state.correosExpress,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.CORREOS_EXPRESS_ECOMMERCE_TRAMO_FAILED:
      return {
        ...state,
        correosExpress: { ...state.correosExpress, loading: false, reload: false },
      }
    case actions.CORREOS_EXPRESS_SOBRES_REQUESTED:
      return {
        ...state,
        correosExpress: { ...state.correosExpress, loading: true, data: null, reload: false },
      }
    case actions.CORREOS_EXPRESS_SOBRES_SUCCEEDED:
      return {
        ...state,
        correosExpress: {
          ...state.correosExpress,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.CORREOS_EXPRESS_SOBRES_FAILED:
      return {
        ...state,
        correosExpress: { ...state.correosExpress, loading: false, reload: false },
      }
    case actions.SEUR_BUSCAR_REQUESTED:
      return { ...state, seurs: { ...state.seurs, loading: true, data: null, reload: false } }
    case actions.SEUR_BUSCAR_SUCCEEDED:
      return {
        ...state,
        seurs: { ...state.seurs, data: action.payload, loading: false, reload: false },
      }
    case actions.SEUR_BUSCAR_FILED:
      return {
        ...state,
        seurs: { ...state.seurs, loading: false, reload: false },
      }
    case actions.SEUR_SEUR_BUSCAR_REQUESTED:
      return { ...state, seurs: { ...state.seurs, loading: true, data: null, reload: false } }
    case actions.SEUR_SEUR_BUSCAR_SUCCEEDED:
      return {
        ...state,
        seurs: { ...state.seurs, data: action.payload, loading: false, reload: false },
      }
    case actions.SEUR_SEUR_BUSCAR_FILED:
      return {
        ...state,
        seurs: { ...state.seurs, loading: false, reload: false },
      }

    case actions.CORREOS_EXPRESS_LOAD_REQUESTED:
      return { ...state, correosExpress: { ...state.correosExpress, loading: true, data: null } }
    case actions.CORREOS_EXPRESS_LOAD_SUCCEEDED:
      return {
        ...state,
        correosExpress: { ...state.correosExpress, data: action.payload, loading: false },
      }
    case actions.CORREOS_EXPRESS_LOAD_FILED:
      return {
        ...state,
        correosExpress: { ...state.correosExpress, loading: false },
      }

    case actions.MRWCLICK_BUSCAR_REQUESTED:
      return {
        ...state,
        mrwsClicks: { ...state.mrwsClicks, loading: true, data: null, reload: false },
      }
    case actions.MRWCLICK_BUSCAR_SUCCEEDED:
      return {
        ...state,
        mrwsClicks: { ...state.mrwsClicks, data: action.payload, loading: false, reload: false },
      }
    case actions.MRWCLICK_BUSCAR_FILED:
      return {
        ...state,
        mrwsClicks: { ...state.mrwsClicks, loading: false, reload: false },
      }
    case actions.MRWCLICK_DIURNOS_REQUESTED:
      return {
        ...state,
        mrwsClicks: { ...state.mrwsClicks, loading: true, data: null, reload: false },
      }
    case actions.MRWCLICK_DIURNOS_SUCCEEDED:
      return {
        ...state,
        mrwsClicks: { ...state.mrwsClicks, data: action.payload, loading: false, reload: false },
      }
    case actions.MRWCLICK_DIURNOS_FILED:
      return {
        ...state,
        mrwsClicks: { ...state.mrwsClicks, loading: false, reload: false },
      }
    case actions.MRWCLICK_NOCTURNOS_REQUESTED:
      return {
        ...state,
        mrwsClicks: { ...state.mrwsClicks, loading: true, data: null, reload: false },
      }
    case actions.MRWCLICK_NOCTURNOS_SUCCEEDED:
      return {
        ...state,
        mrwsClicks: { ...state.mrwsClicks, data: action.payload, loading: false, reload: false },
      }
    case actions.MRWCLICK_NOCTURNOS_FILED:
      return {
        ...state,
        mrwsClicks: { ...state.mrwsClicks, loading: false, reload: false },
      }
    case actions.MRWCLICK_ECOMMERCE_REQUESTED:
      return {
        ...state,
        mrwsClicks: { ...state.mrwsClicks, loading: true, data: null, reload: false },
      }
    case actions.MRWCLICK_ECOMMERCE_SUCCEEDED:
      return {
        ...state,
        mrwsClicks: { ...state.mrwsClicks, data: action.payload, loading: false, reload: false },
      }
    case actions.MRWCLICK_ECOMMERCE_FILED:
      return {
        ...state,
        mrwsClicks: { ...state.mrwsClicks, loading: false, reload: false },
      }

    case actions.MRWCLICK_ECOMMERCETH_REQUESTED:
      return {
        ...state,
        mrwsClicks: { ...state.mrwsClicks, loading: true, data: null, reload: false },
      }
    case actions.MRWCLICK_ECOMMERCETH_SUCCEEDED:
      return {
        ...state,
        mrwsClicks: { ...state.mrwsClicks, data: action.payload, loading: false, reload: false },
      }
    case actions.MRWCLICK_ECOMMERCETH_FILED:
      return {
        ...state,
        mrwsClicks: { ...state.mrwsClicks, loading: false, reload: false },
      }
    case actions.MRWCLICK_SOBRE_REQUESTED:
      return {
        ...state,
        mrwsClicks: { ...state.mrwsClicks, loading: true, data: null, reload: false },
      }
    case actions.MRWCLICK_SOBRE_SUCCEEDED:
      return {
        ...state,
        mrwsClicks: { ...state.mrwsClicks, data: action.payload, loading: false, reload: false },
      }
    case actions.MRWCLICK_SOBRE_FILED:
      return {
        ...state,
        mrwsClicks: { ...state.mrwsClicks, loading: false, reload: false },
      }
    case actions.UPDATE_SEUR_OBJETOS:
      return {
        ...state,
        seurs: { ...state.seurs, data: action.payload },
      }
    case actions.UPDATE_CORREOS_EXPRESS_OBJETOS:
      return {
        ...state,
        correosExpress: { ...state.correosExpress, data: action.payload },
      }
    case actions.CORREOS_EXPRESS_UPDATE_REQUESTED:
      return {
        ...state,
        correosExpress: { ...state.correosExpress, loading: true },
      }
    case actions.CORREOS_EXPRESS_UPDATE_SUCCEEDED:
      return {
        ...state,
        correosExpress: { ...state.correosExpress, loading: false },
      }
    case actions.CORREOS_EXPRESS_UPDATE_FAILED:
      return {
        ...state,
        correosExpress: { ...state.correosExpress, loading: false },
      }
    case actions.UPDATE_DHL_OBJETOS:
      return {
        ...state,
        dhls: { ...state.dhls, data: action.payload },
      }
    case actions.UPDATE_MRWCLICK_OBJETOS:
      return {
        ...state,
        mrwsClicks: { ...state.mrwsClicks, data: action.payload },
      }
    case actions.SEURS_UPDATE_REQUESTED:
      return {
        ...state,
        seurs: { ...state.seurs, loading: true },
      }
    case actions.SEURS_UPDATE_SUCCEEDED:
      return {
        ...state,
        seurs: { ...state.seurs, loading: false },
      }
    case actions.SEURS_UPDATE_FAILED:
      return {
        ...state,
        seurs: { ...state.seurs, loading: false },
      }
    case actions.DHLS_UPDATE_REQUESTED:
      return {
        ...state,
        dhls: { ...state.dhls, loading: true },
      }
    case actions.DHLS_UPDATE_SUCCEEDED:
      // Deliberadamente NO se pone reload: true. El legacy hacia guardar() y luego buscar(), pero
      // ahi ambas operaciones iban contra la misma BD de forma sincrona. Aqui Guardar escribe en
      // logisticapedido.Dhl y publica un evento; venta.Dhl -de donde lee este grid- se actualiza
      // despues, al consumirlo. Recargar en este punto repinta la tabla con los valores previos al
      // guardado y parece que no se hubiera guardado nada (#4437).
      return {
        ...state,
        dhls: { ...state.dhls, loading: false },
      }
    case actions.DHLS_UPDATE_FAILED:
      return {
        ...state,
        dhls: { ...state.dhls, loading: false },
      }
    case actions.SET_DISENO_SVG_VENTA_ITEM_DESCARGADO: {
      const { ventaItemId, disenoClienteId, disenoSvgId, imagenFinalDescargada } = action.payload

      const newState = produce(state, draftState => {
        const ventaItemCarritoAdmin = draftState.venta.data.ventaItemsCarritoAdmin.find(
          i => i.ventaItem.id === ventaItemId,
        )
        const disenoCliente = ventaItemCarritoAdmin.disenosCliente.find(
          i => i.id === disenoClienteId,
        )
        const disenoClienteSvg = disenoCliente.disenoClienteSvgs.find(i => i.id === disenoSvgId)
        disenoClienteSvg.imagenFinalDescargada = imagenFinalDescargada
      })
      return newState
    }
    case actions.DELETE_IMAGEN_FINAL_DISENO_SVG: {
      const { ventaItemId, disenoClienteId, disenoSvgId } = action.payload

      const newState = produce(state, draftState => {
        const ventaItemCarritoAdmin = draftState.venta.data.ventaItemsCarritoAdmin.find(
          i => i.ventaItem.id === ventaItemId,
        )
        const disenoCliente = ventaItemCarritoAdmin.disenosCliente.find(
          i => i.id === disenoClienteId,
        )
        const disenoClienteSvg = disenoCliente.disenoClienteSvgs.find(i => i.id === disenoSvgId)
        disenoClienteSvg.imagenFinalDescargada = false
        disenoClienteSvg.filenameImagenFinal = null
      })
      return newState
    }
    case actions.ADD_LOG_VENTA_ITEM_PERSONALIZADO: {
      const logVentaItemPersonalizado = action.payload
      const newState = produce(state, draftState => {
        const ventaItemCarritoAdmin = draftState.venta.data.ventaItemsCarritoAdmin.find(
          i => i.ventaItem.id === logVentaItemPersonalizado.ventaItemId,
        )
        if (
          !ventaItemCarritoAdmin.ventaItem.logsVentaItemPersonalizado.find(
            l => l.id === logVentaItemPersonalizado.id,
          )
        )
          ventaItemCarritoAdmin.ventaItem.logsVentaItemPersonalizado.push(logVentaItemPersonalizado)
      })
      return newState
    }
    case actions.ADD_LOG_VENTA_ITEM_SEPARADO_REQUESTED:
      return {
        ...state,
        venta: { ...state.venta, loadingItemVenta: true },
      }
    case actions.ADD_LOG_VENTA_ITEM_SEPARADO_SUCCEEDED: {
      const logVentaItemSeparado = action.payload
      const newState = produce(state, draftState => {
        const ventaItemCarritoAdmin = draftState.venta.data.ventaItemsCarritoAdmin.find(
          i => i.ventaItem.id === logVentaItemSeparado.ventaItemId,
        )
        if (
          !ventaItemCarritoAdmin.ventaItem.logsVentaItemSeparado.find(
            l => l.id === logVentaItemSeparado.id,
          )
        )
          ventaItemCarritoAdmin.ventaItem.logsVentaItemSeparado.push(logVentaItemSeparado)
      })
      newState.venta.loadingItemVenta = false
      return newState
    }
    case actions.ADD_LOG_VENTA_ITEM_SEPARADO_FAILED:
      return {
        ...state,
        venta: { ...state.venta, loadingItemVenta: false },
      }
    case actions.ADD_ITEM_VENTA_VERIFICADO_REQUESTED:
      return {
        ...state,
        venta: { ...state.venta, loadingItemVenta: true },
      }
    case actions.ADD_ITEM_VENTA_VERIFICADO_SUCCEEDED: {
      const logVentaItemVerificado = action.payload
      const newState = produce(state, draftState => {
        const ventaItemCarritoAdmin = draftState.venta.data.ventaItemsCarritoAdmin.find(
          i => i.ventaItem.id === logVentaItemVerificado.ventaItemId,
        )
        if (
          !ventaItemCarritoAdmin.ventaItem.logsVentaItemVerificado.find(
            l => l.id === logVentaItemVerificado.id,
          ) || logVentaItemVerificado.id === undefined
        )
          ventaItemCarritoAdmin.ventaItem.logsVentaItemVerificado.push(logVentaItemVerificado)
      })
      newState.venta.loadingItemVenta = false
      return newState
    }
    case actions.ADD_ITEM_VENTA_VERIFICADO_FAILED:
      return {
        ...state,
        venta: { ...state.venta, loadingItemVenta: false },
      }

    case actions.SET_VENTA_ITEM_IMPRIMIR: {
      const modificacionVenta = action.payload
      const newState = produce(state, draftState => {
        const modificacionesVenta = draftState.venta?.data?.modificacionVentaList
        if (!modificacionesVenta?.find(m => m.id === modificacionVenta.id))
          modificacionesVenta.push(modificacionVenta)

        const ventaItemCarritoAdmin = draftState.venta.data.ventaItemsCarritoAdmin.find(
          i => i.ventaItem.id === modificacionVenta.ventaItemId,
        )

        if (ventaItemCarritoAdmin) ventaItemCarritoAdmin.ventaItem.imprimir = modificacionVenta.on
      })
      return newState
    }
    case actions.DELETE_VENTA_ITEMS: {
      const ventaItemIdsEliminados = action.payload
      const newState = produce(state, draftState => {
        const ventaItems = draftState.venta.data.ventaItemsCarritoAdmin
        draftState.venta.data.ventaItemsCarritoAdmin = ventaItems.filter(
          i => !ventaItemIdsEliminados.includes(i.ventaItem.id),
        )
        draftState.ventaItemsMarcadosEliminar = []
      })
      return newState
    }
    case actions.VENTA_ITEM_MARCAR_ELIMINAR: {
      const ventaItemId = action.payload
      const newState = {
        ...state,
        ventaItemsMarcadosEliminar: [...state.ventaItemsMarcadosEliminar, ventaItemId],
      }
      return newState
    }
    case actions.VENTA_ITEM_DESMARCAR_ELIMINAR: {
      const ventaItemId = action.payload
      const newState = {
        ...state,
        ventaItemsMarcadosEliminar: [
          ...state.ventaItemsMarcadosEliminar.filter(i => i !== ventaItemId),
        ],
      }
      return newState
    }
    case actions.VENTA_ITEM_ILUSTRACION_INSERTED: {
      const disenoClienteDto = action.payload
      const newState = produce(state, draftState => {
        const ventaItemCarrito = draftState.venta.data.ventaItemsCarritoAdmin.find(
          ic => ic.ventaItem.id === disenoClienteDto.ventaItemId,
        )
        const disenoCliente = ventaItemCarrito.disenosCliente?.find(
          d => d.id === disenoClienteDto.id,
        )
        if (disenoCliente) {
          const ilustracionesActuales = disenoCliente.ilustraciones
            ? disenoCliente.ilustraciones
            : []
          disenoCliente.ilustraciones = [
            ...ilustracionesActuales,
            ...disenoClienteDto.ilustraciones,
          ]
        } else {
          const disenosActuales = ventaItemCarrito.disenosCliente
            ? ventaItemCarrito.disenosCliente
            : []
          ventaItemCarrito.disenosCliente = [...disenosActuales, disenoClienteDto]
        }
      })
      return newState
    }
    case actions.VENTA_ITEM_ILUSTRACION_DELETED: {
      // El id de ilustración es único en toda la venta, así que se recorren todos los diseños y se
      // quita de donde esté, en vez de localizar antes el diseño por su id.
      const { ilustracionId } = action.payload
      const newState = produce(state, draftState => {
        draftState.venta?.data?.ventaItemsCarritoAdmin?.forEach(ic => {
          ic.disenosCliente?.forEach(disenoCliente => {
            if (Array.isArray(disenoCliente.ilustraciones))
              disenoCliente.ilustraciones = disenoCliente.ilustraciones.filter(
                i => i.id !== ilustracionId,
              )
          })
        })
      })
      return newState
    }
    case actions.ADD_LOG_MAIL_VENTA: {
      const logMailVenta = action.payload
      const newState = produce(state, draftState => {
        if (!draftState.venta?.data?.logsMailVenta?.find(l => l.id === logMailVenta.id))
          draftState.venta.data.logsMailVenta.push(logMailVenta)
      })
      return newState
    }
    case actions.VENTA_ITEM_IMAGENES_INCIDENCIA_INSERTED: {
      const imagenesNuevas = action.payload
      const newState = produce(state, draftState => {
        const ventaItemId = imagenesNuevas[0]?.ventaItemId
        const ventaItem = draftState.venta.data.ventaItemsCarritoAdmin.find(
          v => v.ventaItem.id === ventaItemId,
        )?.ventaItem
        const imagenesNoRepetidas = imagenesNuevas?.filter(
          iExistente => !ventaItem?.imagenesIncidencia?.find(iNueva => iNueva.id === iExistente.id),
        )
        if (ventaItem) {
          ventaItem.imagenesIncidencia = [
            ...(Array.isArray(ventaItem.imagenesIncidencia) ? ventaItem.imagenesIncidencia : []),
            ...imagenesNoRepetidas,
          ]
        }
      })
      return newState
    }
    case actions.VENTA_ITEM_IMAGEN_INCIDENCIA_DELETED: {
      const imagenEliminada = action.payload
      const newState = produce(state, draftState => {
        const ventaItem = draftState.venta.data.ventaItemsCarritoAdmin.find(
          v => v.ventaItem.id === imagenEliminada.ventaItemId,
        )?.ventaItem
        if (ventaItem) {
          ventaItem.imagenesIncidencia = [
            ...(Array.isArray(ventaItem.imagenesIncidencia)
              ? ventaItem.imagenesIncidencia.filter(img => img.id !== imagenEliminada.id)
              : []),
          ]
        }
      })
      return newState
    }
    case actions.VENTA_ITEM_AMAZON_ZIP_INSERTED: {
      const disenosClienteDto = action.payload
      const newState = produce(state, draftState => {
        disenosClienteDto.forEach(disenoClienteDto => {
          const ventaItemCarrito = draftState.venta.data.ventaItemsCarritoAdmin.find(
            ic => ic.ventaItem.id === disenoClienteDto.ventaItemId,
          )
          const disenoCliente = ventaItemCarrito.disenosCliente?.find(
            d => d.id === disenoClienteDto.id,
          )

          disenoClienteDto.disenoClienteSvgs.forEach(d => {
            d.uuid = uuidv4()
          })
          if (disenoCliente) {
            const disenosSvgActuales = disenoCliente.disenoClienteSvgs
              ? disenoCliente.disenoClienteSvgs
              : []
            disenoCliente.disenoClienteSvgs = [
              ...disenosSvgActuales.filter(
                dExistente =>
                  !disenoClienteDto.disenoClienteSvgs.some(dNuevo => dNuevo.id === dExistente.id),
              ),
              ...disenoClienteDto.disenoClienteSvgs,
            ]
            disenoCliente.preguntasAmazon = disenoClienteDto.preguntasAmazon
          } else {
            const disenosActuales = ventaItemCarrito.disenosCliente
              ? ventaItemCarrito.disenosCliente
              : []
            ventaItemCarrito.disenosCliente = [...disenosActuales, disenoClienteDto]
          }
        })
      })
      return newState
    }
    case actions.VENTA_OBSERVACION_PERSONALIZACION_VENTA_INSERTED: {
      const observacionPersonalizacionVenta = action.payload
      const newState = produce(state, draftState => {
        const observacionesActuales = draftState.venta?.data?.observacionesPersonalizacionList
        if (
          observacionesActuales &&
          !observacionesActuales.find(o => o.id === observacionPersonalizacionVenta.id)
        )
          draftState.venta.data.observacionesPersonalizacionList = [
            observacionPersonalizacionVenta,
            ...observacionesActuales,
          ]
      })

      return newState
    }
    case actions.RESET_VENTA_LOAD_REQUESTED:
      return {
        ...state,
        venta: { ...state.venta, loading: state.venta.loading, error: '' },
      }
    case actions.RESET_VENTA_LOAD_SUCCEEDED:
      return {
        ...state,
        venta: {
          ...initialState.venta,
          loading: state.venta.loading,
        },
      }
    case actions.RESET_VENTA_LOAD_FILED:
      return {
        ...state,
        venta: { ...state.venta, loading: state.venta.loading, error: action.error },
      }

    case actions.ADD_VENTA_LOAD_REQUESTED:
      return { ...state, ventas: { ...state.ventas } }
    case actions.ADD_VENTA_LOAD_SUCCEEDED:
      return {
        ...state,
        ventas: { ...state.ventas, data: state.ventas.concat(action.ventas) },
      }
    case actions.ADD_VENTA_LOAD_FILED:
      return {
        ...state,
        venta: { ...state.venta, error: action.error },
      }

    case actions.SET_OBSERVACIONES_BULTO_REQUESTED:
      return {
        ...state,
        venta: { ...state.venta, loadingObservacionesBulto: true, error: '' },
      }
    case actions.SET_OBSERVACIONES_BULTO_SUCCEEDED:
      return {
        ...state,
        venta: {
          ...state.venta,
          loadingObservacionesBulto: false,
          error: '',
          data: {
            ...state.venta?.data,
            observacionesBultos: action.payload,
          },
        },
      }
    case actions.SET_OBSERVACIONES_BULTO_FILED:
      return {
        ...state,
        observaciones: {
          ...state.observaciones,
          loadingObservacionesBulto: false,
          error: action.error,
        },
      }

    case actions.SET_BULTOS_CHECK_REQUESTED:
      return {
        ...state,
        venta: { ...state.venta, loadingBultosCheck: true, error: '' },
      }
    case actions.SET_BULTOS_CHECK_SUCCEEDED:
      return {
        ...state,
        venta: { ...state.venta, loadingBultosCheck: false, error: '' },
      }
    case actions.SET_BULTOS_CHECK_FILED:
      return {
        ...state,
        venta: {
          ...state.venta,
          loadingBultosCheck: false,
          error: action.error,
        },
      }

    case actions.SET_VENTA_FINALIZAR_IMPRIMIR_REQUESTED:
      return {
        ...state,
        venta: { ...state.venta, loadingFinalizarImprimir: true, error: '' },
      }
    case actions.SET_VENTA_FINALIZAR_IMPRIMIR_SUCCEEDED: {
      if (state.venta.data === null) {
        return {
          ...state,
          venta: { ...state.venta, loadingFinalizarImprimir: false, error: '' },
        }
      }

      const newState = produce(state, draftState => {
        if (action.payload.modificacionVentaList !== undefined) {
          draftState.venta.data.modificacionVentaList = action.payload.modificacionVentaList
        }
        draftState.venta.data.estadoId =
          action.payload?.estadoId !== null ? action.payload.estadoId : 0
        draftState.venta.data.status = action.payload.status
        draftState.venta.data.impreso = action.payload.impreso
        draftState.venta.data.cantidadImpreso = action.payload.cantidadImpreso
        if (action.payload.usuarioUltimaImpresionNombre !== undefined) {
          draftState.venta.data.usuarioUltimaImpresionNombre = action.payload.usuarioUltimaImpresionNombre
        }
        if (action.payload.fechaImpreso !== undefined) {
          draftState.venta.data.fechaImpreso = action.payload.fechaImpreso
        }
        draftState.loadingFinalizarImprimir = false
      })

      return newState
    }
    case actions.SET_VENTA_FINALIZAR_IMPRIMIR_FILED:
      return {
        ...state,
        venta: {
          ...state.venta,
          loadingFinalizarImprimir: false,
          error: action.error,
        },
      }

    case actions.GET_ORDEN_ESTANTERIA_REQUESTED:
      return {
        ...state,
        ordenEstanteria: { ...state.ordenEstanteria, loading: true, error: '' },
      }
    case actions.GET_ORDEN_ESTANTERIA_SUCCEEDED:
      return {
        ...state,
        ordenEstanteria: { data: action.payload, loading: false, error: '' },
      }
    case actions.GET_ORDEN_ESTANTERIA_FILED:
      return {
        ...state,
        ordenEstanteria: {
          ...state.ordenEstanteria,
          loading: false,
          error: action.error,
        },
      }

    case actions.SET_ORDEN_ESTANTERIA_REQUESTED:
      return {
        ...state,
        ordenEstanteria: { ...state.ordenEstanteria, loading: true, error: '' },
      }
      case actions.SET_ORDEN_ESTANTERIA_SUCCEEDED:
      return {
        ...state,
        ordenEstanteria: {
          data: action.payload,
          loading: false,
          error: '',
        },
        venta: {
          ...state.venta,
          estanteriaPreseleccionada: null,
          estanteForzado: null,
        },
      }
    case actions.SET_ORDEN_ESTANTERIA_FILED:
      return {
        ...state,
        ordenEstanteria: {
          ...state.ordenEstanteria,
          loading: false,
          error: action.error,
        },
      }
    case actions.GET_ESTANTE_ALEATORIO_REQUESTED:
      return {
        ...state,
        venta: { ...state.venta, loadingEstanteAleatorio: true, error: '' },
      }
    case actions.GET_ESTANTE_ALEATORIO_SUCCEEDED:
      state.venta.estanteriaPreseleccionada = action.payload
      return {
        ...state,
        venta: { ...state.venta, loadingEstanteAleatorio: false, error: '' },
      }
    case actions.GET_ESTANTE_ALEATORIO_FILED:
      return {
        ...state,
        venta: {
          ...state.venta,
          loadingEstanteAleatorio: false,
          error: action.error,
        },
      }

    case actions.SET_VENTA_ESTANTERIA_UPDATE_REQUESTED:
      return {
        ...state,
        venta: { ...state.venta, loadingEstanteAleatorio: true, error: '' },
      }
    case actions.SET_VENTA_ESTANTERIA_UPDATE_SUCCEEDED:
      return {
        ...state,
        venta: {
          ...state.venta,
          data: {
            ...state.venta.data,
            estante: action.payload.estante,
          },
          loadingEstanteAleatorio: false,
          error: '',
          estanteForzado : action.payload.estante,
        },
      }
    case actions.SET_VENTA_ESTANTERIA_UPDATE_FAILED:
      return {
        ...state,
        venta: {
          ...state.venta,
          loadingEstanteAleatorio: false,
          error: action.error,
        },
      }

    case actions.OBSERVACION_CIERRE_VENTA_INSERT_REQUESTED:
      return {
        ...state,
        venta: { ...state.venta, loadingObservacionesCierre: true, error: '' },
      }
    case actions.OBSERVACION_CIERRE_VENTA_INSERT_SUCCEEDED: {
      const observacionCierreVenta = action.payload
      const newState = produce(state, draftState => {
        const observacionesActuales = draftState.venta?.data?.observacionesCierreVentaList
        if (
          observacionesActuales &&
          !observacionesActuales.find(o => o.id === observacionCierreVenta.id)
        ) {
          draftState.venta.data.observacionesCierreVentaList = [
            observacionCierreVenta,
            ...observacionesActuales,
          ]
        }

        draftState.venta.loadingObservacionesCierre = false
      })
      return newState
    }
    case actions.OBSERVACION_CIERRE_VENTA_INSERT_FAILED:
      return {
        ...state,
        venta: {
          ...state.venta,
          loadingObservacionesCierre: false,
          error: action.error,
        },
      }

    case actions.GET_VENTAS_AGRUPADAS_REQUESTED:
      return { ...state, ventas: { ...state.ventas, loading: true } }
    case actions.GET_VENTAS_AGRUPADAS_SUCCEEDED:
      return {
        ...state,
        ventas: { ...state.ventas, data: action.payload, loading: false },
      }
    case actions.GET_VENTAS_AGRUPADAS_FAILED:
      return {
        ...state,
        ventas: { ...state.ventas, loading: false },
      }

    case actions.SET_BANDEJA_PROPUESTA_LOAD_REQUESTED:
      return { ...state, bandejas: { ...state.bandejas, loading: true } }
    case actions.SET_BANDEJA_PROPUESTA_LOAD_SUCCEEDED:
      return {
        ...state,
        bandejas: { ...state.bandejas, data: action.payload, loading: false },
      }
    case actions.SET_BANDEJA_PROPUESTA_LOAD_FAILED:
      return {
        ...state,
        bandejas: { ...state.bandejas, loading: false },
      }

    case actions.GET_MODIFICACIONES_VENTA_REQUESTED:
      return { ...state, modificacionesVenta: { ...state.modificacionesVenta, loading: true } }
    case actions.GET_MODIFICACIONES_VENTA_SUCCEEDED:
      return {
        ...state,
        modificacionesVenta: { ...state.modificacionesVenta, data: action.payload, loading: false },
      }
    case actions.GET_MODIFICACIONES_VENTA_FAILED:
      return {
        ...state,
        modificacionesVenta: { ...state.modificacionesVenta, loading: false },
      }

    case actions.SET_ESTADO_VENTA_REQUESTED:
      return { ...state, ventas: { ...state.ventas } }
    case actions.SET_ESTADO_VENTA_SUCCEEDED: {
      const newData = state.ventas.data.map(venta => {
        if (venta.id === action.payload.id) {
          return {
            ...venta,
            estadoId: action.payload.estadoId,
            usarioSetEstadoId: action.payload.usarioSetEstadoId,
            fechaSetEstado: action.payload.fechaSetEstado,
          }
        }
        return venta
      })
      return {
        ...state,
        ventas: {
          ...state.ventas,
          data: newData,
          loading: false,
        },
      }
    }
    case actions.SET_ESTADO_VENTA_FAILED:
      return { ...state, ventas: { ...state.ventas } }

    case actions.SET_ESTADO_BULTO_VENTA_REQUESTED:
      return { ...state, ventas: { ...state.ventas, loadingEstadoBultoId: action.payload.id } }
    case actions.SET_ESTADO_BULTO_VENTA_SUCCEEDED: {
      const newData = state.ventas.data.map(venta => {
        if (venta.id === action.payload.id) {
          return {
            ...venta,
            estadoBultoId: action.payload.estadoBultoId,
            fechaSetEstado: action.payload.fechaSetEstado,
            usuarioSetEstadoId: action.payload.usuarioSetEstadoId,
          }
        }
        return venta
      })
      return {
        ...state,
        ventas: {
          ...state.ventas,
          data: newData,
          loading: false,
          loadingEstadoBultoId: null,
        },
      }
    }
    case actions.SET_ESTADO_BULTO_VENTA_FAILED:
      return { ...state, ventas: { ...state.ventas, loadingEstadoBultoId: null } }

    case actions.SET_OBSERVACIONES_BULTO_LISTA_REQUESTED:
      return {
        ...state,
        ventas: {
          ...state.ventas,
          loadingObservacionesBultosId: action.payload.id,
          savedObservacionesBultosId: null,
        },
      }
    case actions.SET_OBSERVACIONES_BULTO_LISTA_SUCCEEDED: {
      const newData = state.ventas.data.map(venta => {
        if (venta.id === action.payload.id) {
          return { ...venta, observacionesBultos: action.payload.observacionesBultos }
        }
        return venta
      })
      return {
        ...state,
        ventas: {
          ...state.ventas,
          data: newData,
          loadingObservacionesBultosId: null,
          savedObservacionesBultosId: action.payload.id,
        },
      }
    }
    case actions.SET_OBSERVACIONES_BULTO_LISTA_FAILED:
      return {
        ...state,
        ventas: {
          ...state.ventas,
          loadingObservacionesBultosId: null,
          savedObservacionesBultosId: null,
        },
      }

    case actions.SET_BULTOS_TO_VENTA_REDUCER: {
      const newData = state.ventas.data.map(venta => {
        if (venta.id === action.payload.id) {
          return {
            ...venta,
            bultosCheck: action.payload.bultosCheck,
          }
        }
        return venta
      })
      return {
        ...state,
        ventas: {
          ...state.ventas,
          data: newData,
          loading: false,
        },
      }
    }

    case actions.SET_ESTADO_VENTA_MASIVO_REQUESTED:
      return { ...state, ventas: { ...state.ventas } }
    case actions.SET_ESTADO_VENTA_MASIVO_SUCCEEDED: {
      const newData = state.ventas.data.map(venta => {
        const result = action.payload.find(obj => {
          return obj.id === venta.id
        })

        if (result === undefined) return venta

        return {
          ...venta,
          estadoId: result.estadoId,
          usarioSetEstadoId: result.usarioSetEstadoId,
          fechaSetEstado: result.fechaSetEstado,
          estadoDescripcion: result.estadoDescripcion,
        }
      })
      return {
        ...state,
        ventas: {
          ...state.ventas,
          data: newData,
          loading: false,
        },
      }
    }
    case actions.SET_ESTADO_VENTA_MASIVO_FAILED:
      return { ...state, ventas: { ...state.ventas }, loading: false }

    case actions.SET_ESTADO_MENSAJERIA_VENTA_MASIVO_REQUESTED:
      return { ...state, ventas: { ...state.ventas } }
    case actions.SET_ESTADO_MENSAJERIA_VENTA_MASIVO_SUCCEEDED: {
      const newData = state.ventas.data.map(venta => {
        const result = action.payload.find(obj => {
          return obj.id === venta.id
        })

        if (result === undefined) return venta

        return {
          ...venta,
          estadoMensajeriaId: result.estadoMensajeriaId,
          fechaUltimaActualizacion: result.fechaUltimaActualizacion,
          estadoMensajeriaDescripcion: result.estadoMensajeriaDescripcion,
          transportistaId: result.transportistaId,
          mensajeroSeparado: result.mensajeroSeparado,
          bultosMensajero: result.bultosMensajero,
        }
      })
      return {
        ...state,
        ventas: {
          ...state.ventas,
          data: newData,
          loading: false,
        },
      }
    }
    case actions.SET_VENTAITEM_QUANTITY_SUCEEDED: {
      const { ventaItemId, quantity } = action.payload
      const newState = produce(state, draftState => {
        const ventaItem = draftState.venta?.data?.ventaItems?.find(vi => vi.id === ventaItemId)
        const ventaItemCarrito = draftState.venta?.data?.ventaItemsCarritoAdmin?.find(
          vi => vi?.ventaItem?.id === ventaItemId,
        )
        ventaItem.quantity = quantity
        ventaItemCarrito.ventaItem.quantity = quantity
      })
      return newState
    }
    case actions.SET_VENTAITEMS_PRECIO_SUCEEDED: {
      const { ventaItemsIds, precioUnitario, precioTotal } = action.payload
      const newState = produce(state, draftState => {
        const ventaItems = draftState.venta?.data?.ventaItems?.filter(vi =>
          ventaItemsIds.includes(vi.id),
        )
        const ventaItemsCarrito = draftState.venta?.data?.ventaItemsCarritoAdmin?.filter(vi =>
          ventaItemsIds.includes(vi.ventaItem?.id),
        )

        ventaItems.forEach(ventaItem => {
          ventaItem.precio = precioUnitario
        })

        ventaItemsCarrito.forEach(ventaItem => {
          ventaItem.ventaItem.precio = precioUnitario
        })

        draftState.venta.data.precioTotal = precioTotal
      })
      return newState
    }
    case actions.SET_ESTADO_MENSAJERIA_VENTA_MASIVO_FAILED:
      return { ...state, ventas: { ...state.ventas }, loading: false }

    case actions.GET_PEDIDOS_MENSAJERO_VENTA_REQUESTED:
      return { ...state, pedidosMensajero: { ...state.pedidosMensajero, loading: true } }
    case actions.GET_PEDIDOS_MENSAJERO_VENTA_SUCCEEDED:
      return {
        ...state,
        pedidosMensajero: {
          ...state.pedidosMensajero,
          data: action.payload,
          loading: false,
        },
      }
    case actions.GET_PEDIDOS_MENSAJERO_VENTA_FAILED:
      return {
        ...state,
        pedidosMensajero: { ...state.pedidosMensajero, loading: false },
      }

    case actions.GET_PEDIDOS_SIN_MENSAJERO_VENTA_REQUESTED:
      return { ...state, pedidosSinMensajero: { ...state.pedidosSinMensajero, loading: true } }
    case actions.GET_PEDIDOS_SIN_MENSAJERO_VENTA_SUCCEEDED:
      return {
        ...state,
        pedidosSinMensajero: {
          ...state.pedidosSinMensajero,
          data: action.payload,
          loading: false,
        },
      }
    case actions.GET_PEDIDOS_SIN_MENSAJERO_VENTA_FAILED:
      return {
        ...state,
        pedidosSinMensajero: { ...state.pedidosSinMensajero, loading: false },
      }

    case actions.SET_ORDEN_PEDIDOS_MENSAJERO_REQUESTED:
      return { ...state }
    case actions.SET_ORDEN_PEDIDOS_MENSAJERO_SUCCEEDED:
      const listaOrdenadaIds = action.payload
      const listaReordenada = listaOrdenadaIds.map((id, index) => {
        const item = state.pedidosMensajero.data.find(i => i.ventaId === id)
        return {
          ...item,
          ordenItem: index + 1,
        }
      })
      const listaActualizada = state.pedidosMensajero.data.map(item => {
        const elementoModificado = listaReordenada.find(
          reordenadoItem => reordenadoItem.ventaId === item.ventaId,
        )
        return elementoModificado || item
      })

      return {
        ...state,
        pedidosMensajero: {
          ...state.pedidosMensajero,
          data: listaActualizada,
          loading: false,
        },
      }
    case actions.SET_ORDEN_PEDIDOS_MENSAJERO_FAILED:
      return {
        ...state,
        pedidosMensajero: { ...state.pedidosMensajero, loading: false },
      }

    case actions.SET_DATOS_ENTREGA_VENTA_REQUESTED:
      return { ...state, pedidosMensajero: { ...state.pedidosMensajero, loading: true } }
    case actions.SET_DATOS_ENTREGA_VENTA_SUCCEEDED:
      const newData = state.pedidosMensajero.data.map(d => {
        if (d.ventaId !== action.payload.id) return d
        return {
          ...d,
          horario: action.payload.horario,
          ciudad: action.payload.ciudad,
          cp: action.payload.cp,
          direccion: action.payload.direccion,
        }
      })
      return {
        ...state,
        pedidosMensajero: {
          ...state.pedidosMensajero,
          data: newData,
          loading: false,
        },
      }

    case actions.SET_DATOS_ENTREGA_VENTA_FAILED:
      return {
        ...state,
        pedidosMensajero: { ...state.pedidosMensajero, loading: false },
      }

    case actions.SET_TRANSPORTISTA_VENTA_REQUESTED:
      return {
        ...state,
        ventas: { ...state.ventas, loading: true },
        pedidosMensajero: { ...state.pedidosMensajero, loading: true },
        pedidosSinMensajero: { ...state.pedidosSinMensajero, loading: true },
      }
    case actions.SET_TRANSPORTISTA_VENTA_SUCCEEDED: {
      const dataVentas = state.ventas.data.map(venta => {
        if (venta.id === action.payload.ventaId) {
          return {
            ...venta,
            transportistaId: action.payload.transportistaId,
          }
        }
        return venta
      })
      let datapedidosMensajero = state.pedidosMensajero.data.map(venta => {
        if (venta.ventaId === action.payload.ventaId) {
          return {
            ...venta,
            transportistaId: action.payload.transportistaId,
          }
        }
        return venta
      })
      let datapedidosSinMensajero = state.pedidosSinMensajero.data.map(venta => {
        if (venta.ventaId === action.payload.ventaId) {
          return {
            ...venta,
            transportistaId: action.payload.transportistaId,
          }
        }
        return venta
      })
      const pedidosMensajeroCambiados = datapedidosSinMensajero.filter(
        p => p.transportistaId !== null,
      )
      const pedidosSinMensajeroCambiados = datapedidosMensajero.filter(
        p => p.transportistaId === null,
      )
      datapedidosMensajero = datapedidosMensajero.filter(p => p.transportistaId !== null)
      datapedidosSinMensajero = datapedidosSinMensajero.filter(p => p.transportistaId === null)
      datapedidosMensajero = [...datapedidosMensajero, ...pedidosMensajeroCambiados]
      datapedidosSinMensajero = [...datapedidosSinMensajero, ...pedidosSinMensajeroCambiados]
      return {
        ...state,
        ventas: {
          ...state.ventas,
          data: dataVentas,
          loading: false,
        },
        pedidosMensajero: {
          ...state.pedidosMensajero,
          data: datapedidosMensajero,
          loading: false,
        },
        pedidosSinMensajero: {
          ...state.pedidosSinMensajero,
          data: datapedidosSinMensajero,
          loading: false,
        },
      }
    }
    case actions.SET_TRANSPORTISTA_VENTA_FAILED:
      return {
        ...state,
        ventas: { ...state.ventas, loading: false },
        pedidosMensajero: { ...state.pedidosMensajero, loading: false },
        pedidosSinMensajero: { ...state.pedidosSinMensajero, loading: false },
      }

    case actions.SET_VENTA_MENSAJERO_SEPARADO_REQUESTED:
      return { ...state, pedidosMensajero: { ...state.pedidosMensajero, loading: true } }
    case actions.SET_VENTA_MENSAJERO_SEPARADO_SUCCEEDED:
      const pd = state.pedidosMensajero.data.map(d => {
        if (d.ventaId !== action.payload.id) return d
        return {
          ...d,
          bultosMensajero: action.payload.bultosMensajero,
          mensajeroSeparado: action.payload.mensajeroSeparado,
        }
      })
      return {
        ...state,
        pedidosMensajero: {
          ...state.pedidosMensajero,
          data: pd,
          loading: false,
        },
      }

    case actions.SET_VENTA_MENSAJERO_SEPARADO_FAILED:
      return {
        ...state,
        pedidosMensajero: { ...state.pedidosMensajero, loading: false },
      }
    case actions.INPOST_PUP_ID_UPDATED: {
      const inpostData = action.payload
      const newState = produce(state, draftState => {
        const venta = draftState.venta?.data
        if (venta) {
          venta.inpostPupId = inpostData.inpostPupId
          venta.inpostPupNombre = inpostData.inpostPupNombre
          venta.ciudad = inpostData.ciudad
          venta.cp = inpostData.cp
          venta.direccion = inpostData.direccion
        }
      })
      return newState
    }
    case actions.VENTA_ALBARAN_UPDATED: {
      const { albaran, urlSeguimiento, estadoMensajeriaId } = action.payload
      const newState = produce(state, draftState => {
        const venta = draftState.venta?.data
        if (venta) {
          venta.albaranMensajeria = albaran
          venta.urlSeguimiento = urlSeguimiento
          if (estadoMensajeriaId !== undefined) {
            venta.estadoMensajeriaId = estadoMensajeriaId
          }
        }
      })
      return newState
    }
    case actions.AMAZON_FILTER_REQUESTED:
      return { ...state, pedidosAmazon: { ...state.pedidosAmazon, loading: true } }
    case actions.AMAZON_FILTER_SUCCEEDED:
      return {
        ...state,
        pedidosAmazon: {
          ...state.pedidosAmazon,
          data: action.payload,
          loading: false,
        },
      }
    case actions.AMAZON_FILTER_FAILED:
      return {
        ...state,
        pedidosAmazon: { ...state.pedidosAmazon, loading: false },
      }
    case actions.AMAZON_TRANSMITIR_REQUESTED:
      return { ...state, pedidosAmazon: { ...state.pedidosAmazon, loading: true } }
    case actions.AMAZON_TRANSMITIR_SUCCEEDED:
      return {
        ...state,
        pedidosAmazon: { ...state.pedidosAmazon, loading: false },
      }
    case actions.AMAZON_TRANSMITIR_FAILED:
      return {
        ...state,
        pedidosAmazon: { ...state.pedidosAmazon, loading: false },
      }
    case actions.VENTA_BYID_CONTROLDISENO_LOAD_REQUESTED:
      return {
        ...state,
        venta: { ...state.venta, loading: action?.background ? !action.background : true },
      }
    case actions.VENTA_BYID_CONTROLDISENO_LOAD_SUCCEEDED:
      return {
        ...state,
        venta: { ...state.venta, data: action.payload, loading: false, estanteriaPreseleccionada: null, estanteForzado: null, error: '' },
      }
    case actions.VENTA_BYID_CONTROLDISENO_LOAD_FILED:
      return {
        ...state,
        venta: { ...state.venta, loading: false },
      }

    case actions.SET_ESTANTERIA_PRESELECCIONADA_REQUESTED:
      return {
        ...state,
        venta: { ...state.venta, loadingEstanteAleatorio: true, error: '' },
      }
    case actions.SET_ESTANTERIA_PRESELECCIONADA_SUCCEEDED: {
      console.log('SET_ESTANTERIA_PRESELECCIONADA_SUCCEEDED', action.payload)
      return {
        ...state,
        venta: {
          ...state.venta,
          estanteriaPreseleccionada: action.payload,
          estanteForzado: action.payload,
          loadingEstanteAleatorio: false,
          error: '',
        },
      }
    }
    case actions.SET_ESTANTERIA_PRESELECCIONADA_FAILED:
      return {
        ...state,
        venta: { ...state.venta, loadingEstanteAleatorio: false, error: action.error },
      }
      
    default:
      return state
  }
}
